import React from 'react';
import showdown from 'showdown';
import DOMPurify from 'dompurify';

// Um conversor por opção, no escopo do módulo: `makeHtml` não guarda estado
// entre chamadas, e instanciar por render sai caro na lista de conversas, que
// renderiza um Markdown por item e re-renderiza a cada evento de socket.
const converter = new showdown.Converter({
  simpleLineBreaks: true,
  tables: true,
});

// Mensagens de chat: URL solta vira link, e todo link abre em nova aba. Quem lê
// pode ser o cliente no webchat — navegar na própria aba derrubaria a conversa.
const converterLinks = new showdown.Converter({
  simpleLineBreaks: true,
  tables: true,
  simplifiedAutoLink: true,
  excludeTrailingPunctuationFromURLs: true,
});

// Instância própria: hooks do DOMPurify são globais à instância e não devem
// afetar os outros usos (páginas de política, manual etc.).
const purifierLinks = DOMPurify(window);
purifierLinks.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const Markdown = ({
  value,
  className,
  allowIds = false,
  linksNovaAba = false,
}: {
  value: string;
  className?: string;
  allowIds?: boolean;
  linksNovaAba?: boolean;
}) => {
  if (!value) {
    return null;
  }
  const mdHtml = (linksNovaAba ? converterLinks : converter).makeHtml(value);
  const purified = (linksNovaAba ? purifierLinks : DOMPurify).sanitize(
    mdHtml,
    allowIds ? { ADD_ATTR: ['id'] } : undefined,
  );

  return <div className={className} dangerouslySetInnerHTML={{ __html: purified }} />;
};

// Props são todas primitivas: memo evita reconverter o markdown de itens que
// não mudaram quando a lista re-renderiza.
export default React.memo(Markdown);
